import {ArrayLiteralNode, ASTNode, BinaryOperatorNode, BooleanLiteralNode, FunctionCallNode, GroupNode, NumberLiteralNode, StringLiteralNode, UnaryMinusNode, VariableLookupNode} from 'formula-engine'
import assertNever from '../../global/assetNever'

/**
 * Search formula-engine for VariableLookupNode
 * @param node [ASTNode]
 * @param variables used for recursion
 * @return [Array<VariableLookupNode>]
 */
export function getFormulaVariables(node: ASTNode, variables: VariableLookupNode[] = []): VariableLookupNode[] {
  if (node instanceof ArrayLiteralNode) {
    node.elements.forEach(e => getFormulaVariables(e, variables))
  } else if (node instanceof BinaryOperatorNode) {
    [node.left, node.right].forEach(e => getFormulaVariables(e, variables))
  } else if (node instanceof BooleanLiteralNode) {
    // no variables
  } else if (node instanceof FunctionCallNode) {
    node.parameters.forEach(p => getFormulaVariables(p, variables))
  } else if (node instanceof GroupNode) {
    getFormulaVariables(node.content, variables)
  } else if (node instanceof NumberLiteralNode) {
    // no variables
  } else if (node instanceof StringLiteralNode) {
    // no variables
  } else if (node instanceof UnaryMinusNode) {
    getFormulaVariables(node.operand, variables)
  } else if (node instanceof VariableLookupNode) {
    variables.push(node)
  } else {
    assertNever(node as never)
  }
  return variables
}
